import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=4fb98142"
import script from "./navigation.js?vue&type=script&lang=js&external"
export * from "./navigation.js?vue&type=script&lang=js&external"
import style0 from "./navigation.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports